<template>
    <div class="ingredients-contain">
        <p
            v-if="contains"
            class="contain-info"
        >
            <span class="labeller">{{ $snippet('contains', 'contains') }}</span>: <span v-test:containsInfo>{{ contains }}</span>
        </p>
        <p
            v-if="mayContain"
            class="contain-info"
            v-test:mayContain
        >
            <span class="labeller">{{ $snippet('may_contain', 'may contain') }}</span>: <span v-test:mayContainInfo>{{ mayContain }}</span>
        </p>
    </div>
</template>

<script>
    export default {
        name: 'ingredients-contain',

        props: {
            contains: {
                type: String,
                default: '',
            },

            mayContain: {
                type: String,
                default: '',
            },
        },
    };
</script>

<style lang="scss" scoped>
    .contain-info {
        margin-bottom: 0;
    }

    .labeller {
        font-weight: 700;
    }
</style>
